import moment from "moment";

const formateDate = (date: Date | string | null, format = "DD-MM-YYYY") =>
  date ? moment(date).format(format) : "-";
export default formateDate;
